<mat-card id="maincontent" role='main'>
    @if ( !isLoggedIn ) {
    <mat-card-header>
        <mat-card-title>Claim Your Residency Status</mat-card-title>
    </mat-card-header>
    }
    <mat-card-content>
        <form matForm #loginDialog (ngSubmit)="persistData()">
            @if ( !!isLoggedIn ) {
            <mat-stepper [linear]='!currentLayout?.linear' [selectedIndex]='selected' [orientation]='"horizontal"'
                [class]="isVertical ? 'stepper-orientation stepper-orientation-vertical' : 'stepper-orientation stepper-orientation-horizontal'"
                labelPosition='bottom' (selectionChange)="setStep($event)" role="none">
                <ng-template matStepperIcon="number" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="edit" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="error" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="done" let-index="index">
                    {{index + 1}}
                </ng-template>
                <ng-template matStepperIcon="stepDefinitions[index].step" let-index="index">
                    {{index + 1}}
                </ng-template>
                @for (step of stepDefinitions; track step.step; let index = $index; let last = $last;) {
                @if( isStepVisible(step )) {
                <mat-step state='{{step.step}}' [optional]='isOptional(step)'>
                    @if(isVertical && selected === index ) {
                    <mutara-stepper-header [stepsLength]="stepDefinitions.length" [stepLabel]="step.label"
                        [index]="index"
                        [nextStepLabel]="((index + 1) < stepDefinitions.length) ? stepDefinitions[index + 1].label : ''"
                        [isFixed]="true"></mutara-stepper-header>
                    }
                    <ng-template matStepLabel>
                        <span>{{step.label}}</span>
                    </ng-template>
                    <mutara-form [index]='index' [stepDefinitions]='stepDefinitions'
                        [submitText]='serviceDefinitions.nextStep'>
                    </mutara-form>
                </mat-step>
                }
                }
            </mat-stepper>
            }@else {
            <p>Please use your PantherSoft login to review your residency options, claim your
                residency status, and provide supporting documents.</p>
            <p>By using this software, you are consenting to being contacted by {{schoolName}} in
                connection with your application, and your subsequent relationship with {{schoolName}} as a
                student.
                Communications to and from {{schoolName}} must conform to standards.
                <a href='/aup' target='aup' aria-label="Read the acceptable use policy, opens in a new window">Read
                    the acceptable use policy<mat-icon>open_in_new</mat-icon></a>
            </p>
            <h1 mat-dialog-title>{{activity}}</h1>
            <formly-form [model]='model' [fields]="fields" [form]="form"></formly-form>
            }
        </form>
    </mat-card-content>
</mat-card>